<template>
  <div>
    <iframe 
      height="400" 
      style="width: 100%;" 
      scrolling="no" 
      title="Gamification" 
      src="https://codepen.io/riskypaws/embed/GReBaMw/98f4be6c0a8bb23cd2e83c3ff31a8ec7?default-tab=result&theme-id=47174" 
      frameborder="no" 
      loading="lazy" 
      allowtransparency="true" 
      allowfullscreen="true">
    </iframe>
  </div>
</template>

<script>
export default {
  name: 'EmbedIframe'
}
</script>

<style>
/* You can add styles specific to this component here */
</style>
